"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const CollapseArrowIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("g", { clipPath: "url(#clip0)" },
        react_1.default.createElement("path", { d: "M10 17L16 12L10 7L10 17Z" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip0" },
            react_1.default.createElement("rect", { width: "10", height: "6", fill: "white", transform: "translate(10 17) rotate(-90)" })))));
exports.CollapseArrowIcon = CollapseArrowIcon;
exports.default = exports.CollapseArrowIcon;
